import './languageSwitcher.scss';
import React, {useState} from 'react';
import {Option} from '../common/select/select';
import {Language} from '../i18nTypes';
import {HibuSelect} from '../common/select/hibuSelect';
import classNames from 'clsx';
import updateLanguageActionOnLocalStorage from '../i18n-service';

type LangMap = Partial<Record<Language, Option>>;

type InputProps = {
    className?: string;
    id?: string;
    isDarkBackground: boolean;
    languageOptionsMap: LangMap;
    defaultValue: Language;
    placeholder?: string;
};

export const LanguageSwitcher = React.memo((props: InputProps) => {
    const [selectedLanguage, setSelectedLanguage] = useState<Language>(props.defaultValue);
    const languageOptions = Object.values(props.languageOptionsMap) as Option[];

    const changeLanguage = (selectedOption: Option) => {
        const newLanguage = selectedOption.value;
        setSelectedLanguage(newLanguage);
        updateLanguageActionOnLocalStorage(newLanguage);
    };

    return (
        <HibuSelect
            id={props.id}
            className={classNames('language-switcher', props.isDarkBackground ? 'dark-bg' : '')}
            name="language"
            onChange={changeLanguage}
            value={props.languageOptionsMap[selectedLanguage]}
            options={languageOptions}
        />
    );
});
